(ns manage.ad-variant.creation.template.view
  (:require ["@mui/material/Button$default" :as Button]
            ["src/svg/artwork/template.svg$default" :as TemplateArtwork]
            [common.patterns.empty-state-view :refer [empty-state-view]]
            [common.patterns.loading-view :refer [loading-view]]
            [common.queries :refer [use-query]]
            [common.url-template :as url-tpl]
            [manage.ad-variant.creation.template.add-modal]
            [manage.ad-variant.creation.template.db]
            [manage.ad-variant.creation.template.table :refer [ad-formats-datagrid]]
            [manage.ad-variant.queries :as q]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui empty-view [{:keys [url-context]}]
  ($ empty-state-view
     {:title "Add your template(s)"
      :description "Add templates to start ad creation. Whether for products, services,
                    or your brand, find your fit. Let's craft your variants! 🎨"
      :artwork TemplateArtwork
      :docs-href (url-tpl/render :docs/article (assoc url-context :slug "23852211701532-How-to-Create-Ad-Variants"))
      :actions ($ Button {:type "submit"
                          :variant "contained"
                          :onClick #(rf/dispatch [:modal/open {:id :ad-variant/add-template-modal}])}
                  "Add Templates")}))

(defui template-view []
  (let [{:keys [adset-id] :as url-context} (use-subscribe [:url-context])
        {:keys [isInitialLoading data] :as ad-builders-upgrade-hints-reponse}
        (use-query (q/ad-builders-upgrade-hints-query {:adset-id adset-id}))]
    (cond
      isInitialLoading ($ loading-view)
      (seq data) ($ ad-formats-datagrid
                    {:ad-builders-upgrade-hints-reponse ad-builders-upgrade-hints-reponse})
      :else ($ empty-view {:url-context url-context}))))
